/**
 * The role a stakeholder plays on a feedback round.
 * Mirrors App\Enums\StakeholderRole.
 *
 * Separate from ownership: the round's creator carries `isOwner`, which never changes,
 * while their role is as editable as anyone's. `Owner` is reserved — only the flagged
 * owner may hold it.
 */
export enum StakeholderRole {
  Owner = 'owner',
  Developer = 'developer',
  ProjectManager = 'project_manager',
  UxDesigner = 'ux_designer',
  /** Gets the same emails as a Project Manager. */
  UxConsultant = 'ux_consultant',
  LeftFeedback = 'left_feedback',
  Contributor = 'contributor',
}
